<mat-form-field>
  <mat-select [formControl]="languageCtrl">
    <mat-select-trigger>
      {{ (value + "_lang") | translate }}
    </mat-select-trigger>
    @for (language of languages; track language) {
    <mat-option [value]="language">{{ (language + "_lang") | translate }}</mat-option>
    }
  </mat-select>
</mat-form-field>
